module.exports = __webpack_public_path__ + "static/img/3-Who-will-support-me-1024x1024.bbe0db8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-Who-will-support-me-1024x1024.png
// module id = witc
// module chunks = 0